var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08829 6.99995C9.08829 8.15495 8.15495 9.08829 6.99995 9.08829C5.84495 9.08829 4.91162 8.15495 4.91162 6.99995C4.91162 5.84495 5.84495 4.91162 6.99995 4.91162C8.15495 4.91162 9.08829 5.84495 9.08829 6.99995Z",
    stroke: "#68616D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00003 11.8242C9.0592 11.8242 10.9784 10.6109 12.3142 8.51088C12.8392 7.68838 12.8392 6.30588 12.3142 5.48338C10.9784 3.38338 9.0592 2.17004 7.00003 2.17004C4.94086 2.17004 3.0217 3.38338 1.68586 5.48338C1.16086 6.30588 1.16086 7.68838 1.68586 8.51088C3.0217 10.6109 4.94086 11.8242 7.00003 11.8242Z",
    stroke: "#68616D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d16be4932fbfbac8868b77d9c63f9cf1.svg";
export { ForwardRef as ReactComponent };